/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks JobClassification API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Request body for bulk operations. - Omit \'ids\' or provide empty array to target all entities - Provide \'ids\' array with one or more IDs to target specific entities 
 */
export interface BulkOperationRequest {
    /**
     * Optional array of specific entity IDs to target for the operation. If not provided or empty, targets all entities. 
     */
    'ids'?: Array<string>;
}
export interface BulkReplaceResult {
    /**
     * Number of records inserted
     */
    'inserted': number;
    /**
     * Number of existing records deleted before insertion
     */
    'deleted': number;
}
export interface BulkUpsertResult {
    /**
     * Number of records inserted (new)
     */
    'inserted': number;
    /**
     * Number of records updated (existing)
     */
    'updated': number;
}
export interface Competency {
    'id'?: string;
    /**
     * Competency name
     */
    'name': string;
}
export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
export interface JobClassificationCode {
    'id'?: string;
    /**
     * Job classification code
     */
    'code': string;
    /**
     * Job classification title
     */
    'title': string;
    /**
     * Associated job level ID
     */
    'jobLevelId'?: string;
}
/**
 * Defines the relationship of a single Skill to a single Job Family, with one or many Job Classification Codes. Each record is unique by (skillId, jobFamilyId). 
 */
export interface JobClassificationSkillMapping {
    'id'?: string;
    /**
     * Job family ID
     */
    'jobFamilyId': string;
    /**
     * Skill ID
     */
    'skillId': string;
    /**
     * Job classification code IDs linked to this skill + job family
     */
    'jobClassificationCodeIds': Array<string>;
}
export interface JobFamily {
    'id'?: string;
    /**
     * Job family name
     */
    'name': string;
}
export interface JobFamilyCompetencyMapping {
    'id'?: string;
    /**
     * Job family ID
     */
    'jobFamilyId': string;
    /**
     * Competency ID
     */
    'competencyId': string;
}
export interface JobLevel {
    'id'?: string;
    /**
     * Job level name
     */
    'name': string;
    /**
     * Experience years requirement (e.g., \"0-2 years\", \"5-8 years\", \"8+ years\")
     */
    'experienceYears'?: string;
}
export interface OperationResult {
    /**
     * Number of items successfully processed
     */
    'successCount': number;
    /**
     * Total number of items targeted for processing
     */
    'totalCount': number;
    /**
     * Number of items that failed processing
     */
    'failedCount': number;
}
export interface Skill {
    'id'?: string;
    /**
     * Skill name
     */
    'name': string;
    /**
     * Associated skill cluster ID
     */
    'skillClusterId': string;
    /**
     * Associated skill type ID
     */
    'skillTypeId': string;
    /**
     * Associated skill level ID
     */
    'skillLevelId': string;
}
export interface SkillCluster {
    'id'?: string;
    /**
     * Skill cluster name
     */
    'name': string;
    /**
     * Associated skill type ID (optional)
     */
    'skillTypeId'?: string;
}
export interface SkillLevel {
    'id'?: string;
    /**
     * Skill level name
     */
    'name': string;
    /**
     * Numeric skill level (1-4)
     */
    'level': number;
}
export interface SkillType {
    'id'?: string;
    /**
     * Skill type name
     */
    'name': string;
}

/**
 * CompetenciesApi - axios parameter creator
 */
export const CompetenciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new competency
         * @param {Competency} competency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompetency: async (competency: Competency, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competency' is not null or undefined
            assertParamExists('createCompetency', 'competency', competency)
            const localVarPath = `/api/job-classification/competencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(competency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all competencies based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific competencies. Omit \'ids\' or provide empty array to delete all competencies (requires elevated permissions). 
         * @summary Delete competencies (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompetenciesBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteCompetenciesBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/competencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a competency
         * @param {string} id Unique identifier of the competency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompetency: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompetency', 'id', id)
            const localVarPath = `/api/job-classification/competencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a competency by ID
         * @param {string} id Unique identifier of the competency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompetency: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompetency', 'id', id)
            const localVarPath = `/api/job-classification/competencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all competencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompetencies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/competencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a competency
         * @param {string} id Unique identifier of the competency
         * @param {Competency} competency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompetency: async (id: string, competency: Competency, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompetency', 'id', id)
            // verify required parameter 'competency' is not null or undefined
            assertParamExists('updateCompetency', 'competency', competency)
            const localVarPath = `/api/job-classification/competencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(competency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompetenciesApi - functional programming interface
 */
export const CompetenciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompetenciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new competency
         * @param {Competency} competency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompetency(competency: Competency, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Competency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompetency(competency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetenciesApi.createCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all competencies based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific competencies. Omit \'ids\' or provide empty array to delete all competencies (requires elevated permissions). 
         * @summary Delete competencies (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompetenciesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompetenciesBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetenciesApi.deleteCompetenciesBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a competency
         * @param {string} id Unique identifier of the competency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompetency(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompetency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetenciesApi.deleteCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a competency by ID
         * @param {string} id Unique identifier of the competency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompetency(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Competency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompetency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetenciesApi.getCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all competencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompetencies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Competency>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompetencies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetenciesApi.listCompetencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a competency
         * @param {string} id Unique identifier of the competency
         * @param {Competency} competency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompetency(id: string, competency: Competency, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Competency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompetency(id, competency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetenciesApi.updateCompetency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompetenciesApi - factory interface
 */
export const CompetenciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompetenciesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new competency
         * @param {Competency} competency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompetency(competency: Competency, options?: RawAxiosRequestConfig): AxiosPromise<Competency> {
            return localVarFp.createCompetency(competency, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all competencies based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific competencies. Omit \'ids\' or provide empty array to delete all competencies (requires elevated permissions). 
         * @summary Delete competencies (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompetenciesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteCompetenciesBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a competency
         * @param {string} id Unique identifier of the competency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompetency(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCompetency(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a competency by ID
         * @param {string} id Unique identifier of the competency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompetency(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Competency> {
            return localVarFp.getCompetency(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all competencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompetencies(options?: RawAxiosRequestConfig): AxiosPromise<Array<Competency>> {
            return localVarFp.listCompetencies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a competency
         * @param {string} id Unique identifier of the competency
         * @param {Competency} competency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompetency(id: string, competency: Competency, options?: RawAxiosRequestConfig): AxiosPromise<Competency> {
            return localVarFp.updateCompetency(id, competency, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompetenciesApi - object-oriented interface
 */
export class CompetenciesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new competency
     * @param {Competency} competency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCompetency(competency: Competency, options?: RawAxiosRequestConfig) {
        return CompetenciesApiFp(this.configuration).createCompetency(competency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all competencies based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific competencies. Omit \'ids\' or provide empty array to delete all competencies (requires elevated permissions). 
     * @summary Delete competencies (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCompetenciesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return CompetenciesApiFp(this.configuration).deleteCompetenciesBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a competency
     * @param {string} id Unique identifier of the competency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCompetency(id: string, options?: RawAxiosRequestConfig) {
        return CompetenciesApiFp(this.configuration).deleteCompetency(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a competency by ID
     * @param {string} id Unique identifier of the competency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompetency(id: string, options?: RawAxiosRequestConfig) {
        return CompetenciesApiFp(this.configuration).getCompetency(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all competencies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCompetencies(options?: RawAxiosRequestConfig) {
        return CompetenciesApiFp(this.configuration).listCompetencies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a competency
     * @param {string} id Unique identifier of the competency
     * @param {Competency} competency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCompetency(id: string, competency: Competency, options?: RawAxiosRequestConfig) {
        return CompetenciesApiFp(this.configuration).updateCompetency(id, competency, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobClassificationCodesApi - axios parameter creator
 */
export const JobClassificationCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new job classification code
         * @param {JobClassificationCode} jobClassificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobClassificationCode: async (jobClassificationCode: JobClassificationCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobClassificationCode' is not null or undefined
            assertParamExists('createJobClassificationCode', 'jobClassificationCode', jobClassificationCode)
            const localVarPath = `/api/job-classification/job-classification-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobClassificationCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job classification code
         * @param {string} id Unique identifier of the job classification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobClassificationCode', 'id', id)
            const localVarPath = `/api/job-classification/job-classification-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all job classification codes based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific codes. Omit \'ids\' or provide empty array to delete all codes (requires elevated permissions). 
         * @summary Delete job classification codes (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationCodesBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteJobClassificationCodesBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/job-classification-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job classification code by ID
         * @param {string} id Unique identifier of the job classification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobClassificationCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobClassificationCode', 'id', id)
            const localVarPath = `/api/job-classification/job-classification-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List job classification codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobClassificationCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/job-classification-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job classification code
         * @param {string} id Unique identifier of the job classification code
         * @param {JobClassificationCode} jobClassificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobClassificationCode: async (id: string, jobClassificationCode: JobClassificationCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobClassificationCode', 'id', id)
            // verify required parameter 'jobClassificationCode' is not null or undefined
            assertParamExists('updateJobClassificationCode', 'jobClassificationCode', jobClassificationCode)
            const localVarPath = `/api/job-classification/job-classification-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobClassificationCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload job classification codes from CSV file
         * @param {File} file CSV file with job classification code data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJobClassificationCodesCsv: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadJobClassificationCodesCsv', 'file', file)
            const localVarPath = `/api/job-classification/job-classification-codes/upload-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobClassificationCodesApi - functional programming interface
 */
export const JobClassificationCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobClassificationCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new job classification code
         * @param {JobClassificationCode} jobClassificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobClassificationCode(jobClassificationCode: JobClassificationCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobClassificationCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobClassificationCode(jobClassificationCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.createJobClassificationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job classification code
         * @param {string} id Unique identifier of the job classification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobClassificationCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobClassificationCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.deleteJobClassificationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all job classification codes based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific codes. Omit \'ids\' or provide empty array to delete all codes (requires elevated permissions). 
         * @summary Delete job classification codes (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobClassificationCodesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobClassificationCodesBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.deleteJobClassificationCodesBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job classification code by ID
         * @param {string} id Unique identifier of the job classification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobClassificationCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobClassificationCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobClassificationCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.getJobClassificationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List job classification codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobClassificationCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobClassificationCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobClassificationCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.listJobClassificationCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job classification code
         * @param {string} id Unique identifier of the job classification code
         * @param {JobClassificationCode} jobClassificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJobClassificationCode(id: string, jobClassificationCode: JobClassificationCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobClassificationCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJobClassificationCode(id, jobClassificationCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.updateJobClassificationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload job classification codes from CSV file
         * @param {File} file CSV file with job classification code data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadJobClassificationCodesCsv(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkReplaceResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadJobClassificationCodesCsv(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationCodesApi.uploadJobClassificationCodesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobClassificationCodesApi - factory interface
 */
export const JobClassificationCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobClassificationCodesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new job classification code
         * @param {JobClassificationCode} jobClassificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobClassificationCode(jobClassificationCode: JobClassificationCode, options?: RawAxiosRequestConfig): AxiosPromise<JobClassificationCode> {
            return localVarFp.createJobClassificationCode(jobClassificationCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job classification code
         * @param {string} id Unique identifier of the job classification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteJobClassificationCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all job classification codes based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific codes. Omit \'ids\' or provide empty array to delete all codes (requires elevated permissions). 
         * @summary Delete job classification codes (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationCodesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteJobClassificationCodesBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job classification code by ID
         * @param {string} id Unique identifier of the job classification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobClassificationCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<JobClassificationCode> {
            return localVarFp.getJobClassificationCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List job classification codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobClassificationCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobClassificationCode>> {
            return localVarFp.listJobClassificationCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job classification code
         * @param {string} id Unique identifier of the job classification code
         * @param {JobClassificationCode} jobClassificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobClassificationCode(id: string, jobClassificationCode: JobClassificationCode, options?: RawAxiosRequestConfig): AxiosPromise<JobClassificationCode> {
            return localVarFp.updateJobClassificationCode(id, jobClassificationCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload job classification codes from CSV file
         * @param {File} file CSV file with job classification code data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJobClassificationCodesCsv(file: File, options?: RawAxiosRequestConfig): AxiosPromise<BulkReplaceResult> {
            return localVarFp.uploadJobClassificationCodesCsv(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobClassificationCodesApi - object-oriented interface
 */
export class JobClassificationCodesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new job classification code
     * @param {JobClassificationCode} jobClassificationCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJobClassificationCode(jobClassificationCode: JobClassificationCode, options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).createJobClassificationCode(jobClassificationCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job classification code
     * @param {string} id Unique identifier of the job classification code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobClassificationCode(id: string, options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).deleteJobClassificationCode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all job classification codes based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific codes. Omit \'ids\' or provide empty array to delete all codes (requires elevated permissions). 
     * @summary Delete job classification codes (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobClassificationCodesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).deleteJobClassificationCodesBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job classification code by ID
     * @param {string} id Unique identifier of the job classification code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobClassificationCode(id: string, options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).getJobClassificationCode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List job classification codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listJobClassificationCodes(options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).listJobClassificationCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job classification code
     * @param {string} id Unique identifier of the job classification code
     * @param {JobClassificationCode} jobClassificationCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJobClassificationCode(id: string, jobClassificationCode: JobClassificationCode, options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).updateJobClassificationCode(id, jobClassificationCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload job classification codes from CSV file
     * @param {File} file CSV file with job classification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadJobClassificationCodesCsv(file: File, options?: RawAxiosRequestConfig) {
        return JobClassificationCodesApiFp(this.configuration).uploadJobClassificationCodesCsv(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobClassificationSkillMappingsApi - axios parameter creator
 */
export const JobClassificationSkillMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a job classification skill mapping (skill + job family + many codes)
         * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobClassificationSkillMapping: async (jobClassificationSkillMapping: JobClassificationSkillMapping, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobClassificationSkillMapping' is not null or undefined
            assertParamExists('createJobClassificationSkillMapping', 'jobClassificationSkillMapping', jobClassificationSkillMapping)
            const localVarPath = `/api/job-classification/mappings/job-classification-skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobClassificationSkillMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job classification skill mapping
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationSkillMapping: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobClassificationSkillMapping', 'id', id)
            const localVarPath = `/api/job-classification/mappings/job-classification-skills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all job classification skill mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
         * @summary Delete job classification skill mappings (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationSkillMappingsBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteJobClassificationSkillMappingsBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/mappings/job-classification-skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job classification skill mapping by ID
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobClassificationSkillMapping: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobClassificationSkillMapping', 'id', id)
            const localVarPath = `/api/job-classification/mappings/job-classification-skills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List job classification skill mappings (one row per skill + job family)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobClassificationSkillMappings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/mappings/job-classification-skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job classification skill mapping (skill + job family + codes)
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobClassificationSkillMapping: async (id: string, jobClassificationSkillMapping: JobClassificationSkillMapping, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobClassificationSkillMapping', 'id', id)
            // verify required parameter 'jobClassificationSkillMapping' is not null or undefined
            assertParamExists('updateJobClassificationSkillMapping', 'jobClassificationSkillMapping', jobClassificationSkillMapping)
            const localVarPath = `/api/job-classification/mappings/job-classification-skills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobClassificationSkillMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload job classification skill mappings from CSV file
         * @param {File} file CSV file with job classification skill mapping data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJobClassificationSkillMappingsCsv: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadJobClassificationSkillMappingsCsv', 'file', file)
            const localVarPath = `/api/job-classification/mappings/job-classification-skills/upload-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobClassificationSkillMappingsApi - functional programming interface
 */
export const JobClassificationSkillMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobClassificationSkillMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a job classification skill mapping (skill + job family + many codes)
         * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobClassificationSkillMapping(jobClassificationSkillMapping: JobClassificationSkillMapping, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobClassificationSkillMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobClassificationSkillMapping(jobClassificationSkillMapping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.createJobClassificationSkillMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job classification skill mapping
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobClassificationSkillMapping(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobClassificationSkillMapping(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.deleteJobClassificationSkillMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all job classification skill mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
         * @summary Delete job classification skill mappings (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobClassificationSkillMappingsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobClassificationSkillMappingsBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.deleteJobClassificationSkillMappingsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job classification skill mapping by ID
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobClassificationSkillMapping(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobClassificationSkillMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobClassificationSkillMapping(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.getJobClassificationSkillMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List job classification skill mappings (one row per skill + job family)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobClassificationSkillMappings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobClassificationSkillMapping>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobClassificationSkillMappings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.listJobClassificationSkillMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job classification skill mapping (skill + job family + codes)
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJobClassificationSkillMapping(id: string, jobClassificationSkillMapping: JobClassificationSkillMapping, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobClassificationSkillMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJobClassificationSkillMapping(id, jobClassificationSkillMapping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.updateJobClassificationSkillMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload job classification skill mappings from CSV file
         * @param {File} file CSV file with job classification skill mapping data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadJobClassificationSkillMappingsCsv(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpsertResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadJobClassificationSkillMappingsCsv(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobClassificationSkillMappingsApi.uploadJobClassificationSkillMappingsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobClassificationSkillMappingsApi - factory interface
 */
export const JobClassificationSkillMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobClassificationSkillMappingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a job classification skill mapping (skill + job family + many codes)
         * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobClassificationSkillMapping(jobClassificationSkillMapping: JobClassificationSkillMapping, options?: RawAxiosRequestConfig): AxiosPromise<JobClassificationSkillMapping> {
            return localVarFp.createJobClassificationSkillMapping(jobClassificationSkillMapping, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job classification skill mapping
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationSkillMapping(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteJobClassificationSkillMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all job classification skill mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
         * @summary Delete job classification skill mappings (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobClassificationSkillMappingsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteJobClassificationSkillMappingsBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job classification skill mapping by ID
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobClassificationSkillMapping(id: string, options?: RawAxiosRequestConfig): AxiosPromise<JobClassificationSkillMapping> {
            return localVarFp.getJobClassificationSkillMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List job classification skill mappings (one row per skill + job family)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobClassificationSkillMappings(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobClassificationSkillMapping>> {
            return localVarFp.listJobClassificationSkillMappings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job classification skill mapping (skill + job family + codes)
         * @param {string} id Unique identifier of the job classification skill mapping
         * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobClassificationSkillMapping(id: string, jobClassificationSkillMapping: JobClassificationSkillMapping, options?: RawAxiosRequestConfig): AxiosPromise<JobClassificationSkillMapping> {
            return localVarFp.updateJobClassificationSkillMapping(id, jobClassificationSkillMapping, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload job classification skill mappings from CSV file
         * @param {File} file CSV file with job classification skill mapping data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJobClassificationSkillMappingsCsv(file: File, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpsertResult> {
            return localVarFp.uploadJobClassificationSkillMappingsCsv(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobClassificationSkillMappingsApi - object-oriented interface
 */
export class JobClassificationSkillMappingsApi extends BaseAPI {
    /**
     * 
     * @summary Create a job classification skill mapping (skill + job family + many codes)
     * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJobClassificationSkillMapping(jobClassificationSkillMapping: JobClassificationSkillMapping, options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).createJobClassificationSkillMapping(jobClassificationSkillMapping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job classification skill mapping
     * @param {string} id Unique identifier of the job classification skill mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobClassificationSkillMapping(id: string, options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).deleteJobClassificationSkillMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all job classification skill mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
     * @summary Delete job classification skill mappings (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobClassificationSkillMappingsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).deleteJobClassificationSkillMappingsBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job classification skill mapping by ID
     * @param {string} id Unique identifier of the job classification skill mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobClassificationSkillMapping(id: string, options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).getJobClassificationSkillMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List job classification skill mappings (one row per skill + job family)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listJobClassificationSkillMappings(options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).listJobClassificationSkillMappings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job classification skill mapping (skill + job family + codes)
     * @param {string} id Unique identifier of the job classification skill mapping
     * @param {JobClassificationSkillMapping} jobClassificationSkillMapping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJobClassificationSkillMapping(id: string, jobClassificationSkillMapping: JobClassificationSkillMapping, options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).updateJobClassificationSkillMapping(id, jobClassificationSkillMapping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload job classification skill mappings from CSV file
     * @param {File} file CSV file with job classification skill mapping data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadJobClassificationSkillMappingsCsv(file: File, options?: RawAxiosRequestConfig) {
        return JobClassificationSkillMappingsApiFp(this.configuration).uploadJobClassificationSkillMappingsCsv(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobFamiliesApi - axios parameter creator
 */
export const JobFamiliesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new job family
         * @param {JobFamily} jobFamily 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobFamily: async (jobFamily: JobFamily, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobFamily' is not null or undefined
            assertParamExists('createJobFamily', 'jobFamily', jobFamily)
            const localVarPath = `/api/job-classification/job-families`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobFamily, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all job families based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific families. Omit \'ids\' or provide empty array to delete all families (requires elevated permissions). 
         * @summary Delete job families (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamiliesBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteJobFamiliesBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/job-families`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job family
         * @param {string} id Unique identifier of the job family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamily: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobFamily', 'id', id)
            const localVarPath = `/api/job-classification/job-families/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job family by ID
         * @param {string} id Unique identifier of the job family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobFamily: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobFamily', 'id', id)
            const localVarPath = `/api/job-classification/job-families/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all job families
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobFamilies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/job-families`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job family
         * @param {string} id Unique identifier of the job family
         * @param {JobFamily} jobFamily 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobFamily: async (id: string, jobFamily: JobFamily, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobFamily', 'id', id)
            // verify required parameter 'jobFamily' is not null or undefined
            assertParamExists('updateJobFamily', 'jobFamily', jobFamily)
            const localVarPath = `/api/job-classification/job-families/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobFamily, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobFamiliesApi - functional programming interface
 */
export const JobFamiliesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobFamiliesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new job family
         * @param {JobFamily} jobFamily 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobFamily(jobFamily: JobFamily, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobFamily>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobFamily(jobFamily, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamiliesApi.createJobFamily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all job families based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific families. Omit \'ids\' or provide empty array to delete all families (requires elevated permissions). 
         * @summary Delete job families (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobFamiliesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobFamiliesBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamiliesApi.deleteJobFamiliesBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job family
         * @param {string} id Unique identifier of the job family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobFamily(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobFamily(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamiliesApi.deleteJobFamily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job family by ID
         * @param {string} id Unique identifier of the job family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobFamily(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobFamily>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobFamily(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamiliesApi.getJobFamily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all job families
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobFamilies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobFamily>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobFamilies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamiliesApi.listJobFamilies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job family
         * @param {string} id Unique identifier of the job family
         * @param {JobFamily} jobFamily 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJobFamily(id: string, jobFamily: JobFamily, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobFamily>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJobFamily(id, jobFamily, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamiliesApi.updateJobFamily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobFamiliesApi - factory interface
 */
export const JobFamiliesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobFamiliesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new job family
         * @param {JobFamily} jobFamily 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobFamily(jobFamily: JobFamily, options?: RawAxiosRequestConfig): AxiosPromise<JobFamily> {
            return localVarFp.createJobFamily(jobFamily, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all job families based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific families. Omit \'ids\' or provide empty array to delete all families (requires elevated permissions). 
         * @summary Delete job families (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamiliesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteJobFamiliesBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job family
         * @param {string} id Unique identifier of the job family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamily(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteJobFamily(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job family by ID
         * @param {string} id Unique identifier of the job family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobFamily(id: string, options?: RawAxiosRequestConfig): AxiosPromise<JobFamily> {
            return localVarFp.getJobFamily(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all job families
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobFamilies(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobFamily>> {
            return localVarFp.listJobFamilies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job family
         * @param {string} id Unique identifier of the job family
         * @param {JobFamily} jobFamily 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobFamily(id: string, jobFamily: JobFamily, options?: RawAxiosRequestConfig): AxiosPromise<JobFamily> {
            return localVarFp.updateJobFamily(id, jobFamily, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobFamiliesApi - object-oriented interface
 */
export class JobFamiliesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new job family
     * @param {JobFamily} jobFamily 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJobFamily(jobFamily: JobFamily, options?: RawAxiosRequestConfig) {
        return JobFamiliesApiFp(this.configuration).createJobFamily(jobFamily, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all job families based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific families. Omit \'ids\' or provide empty array to delete all families (requires elevated permissions). 
     * @summary Delete job families (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobFamiliesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return JobFamiliesApiFp(this.configuration).deleteJobFamiliesBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job family
     * @param {string} id Unique identifier of the job family
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobFamily(id: string, options?: RawAxiosRequestConfig) {
        return JobFamiliesApiFp(this.configuration).deleteJobFamily(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job family by ID
     * @param {string} id Unique identifier of the job family
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobFamily(id: string, options?: RawAxiosRequestConfig) {
        return JobFamiliesApiFp(this.configuration).getJobFamily(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all job families
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listJobFamilies(options?: RawAxiosRequestConfig) {
        return JobFamiliesApiFp(this.configuration).listJobFamilies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job family
     * @param {string} id Unique identifier of the job family
     * @param {JobFamily} jobFamily 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJobFamily(id: string, jobFamily: JobFamily, options?: RawAxiosRequestConfig) {
        return JobFamiliesApiFp(this.configuration).updateJobFamily(id, jobFamily, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobFamilyCompetencyMappingsApi - axios parameter creator
 */
export const JobFamilyCompetencyMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new job family competency mapping
         * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobFamilyCompetencyMapping: async (jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobFamilyCompetencyMapping' is not null or undefined
            assertParamExists('createJobFamilyCompetencyMapping', 'jobFamilyCompetencyMapping', jobFamilyCompetencyMapping)
            const localVarPath = `/api/job-classification/mappings/job-family-competencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobFamilyCompetencyMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job family competency mapping
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamilyCompetencyMapping: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobFamilyCompetencyMapping', 'id', id)
            const localVarPath = `/api/job-classification/mappings/job-family-competencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all job family competency mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
         * @summary Delete job family competency mappings (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamilyCompetencyMappingsBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteJobFamilyCompetencyMappingsBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/mappings/job-family-competencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job family competency mapping by ID
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobFamilyCompetencyMapping: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobFamilyCompetencyMapping', 'id', id)
            const localVarPath = `/api/job-classification/mappings/job-family-competencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List job family competency mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobFamilyCompetencyMappings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/mappings/job-family-competencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job family competency mapping
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobFamilyCompetencyMapping: async (id: string, jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobFamilyCompetencyMapping', 'id', id)
            // verify required parameter 'jobFamilyCompetencyMapping' is not null or undefined
            assertParamExists('updateJobFamilyCompetencyMapping', 'jobFamilyCompetencyMapping', jobFamilyCompetencyMapping)
            const localVarPath = `/api/job-classification/mappings/job-family-competencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobFamilyCompetencyMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobFamilyCompetencyMappingsApi - functional programming interface
 */
export const JobFamilyCompetencyMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobFamilyCompetencyMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new job family competency mapping
         * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobFamilyCompetencyMapping(jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobFamilyCompetencyMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobFamilyCompetencyMapping(jobFamilyCompetencyMapping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamilyCompetencyMappingsApi.createJobFamilyCompetencyMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job family competency mapping
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobFamilyCompetencyMapping(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobFamilyCompetencyMapping(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamilyCompetencyMappingsApi.deleteJobFamilyCompetencyMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all job family competency mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
         * @summary Delete job family competency mappings (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobFamilyCompetencyMappingsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobFamilyCompetencyMappingsBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamilyCompetencyMappingsApi.deleteJobFamilyCompetencyMappingsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job family competency mapping by ID
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobFamilyCompetencyMapping(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobFamilyCompetencyMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobFamilyCompetencyMapping(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamilyCompetencyMappingsApi.getJobFamilyCompetencyMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List job family competency mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobFamilyCompetencyMappings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobFamilyCompetencyMapping>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobFamilyCompetencyMappings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamilyCompetencyMappingsApi.listJobFamilyCompetencyMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job family competency mapping
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJobFamilyCompetencyMapping(id: string, jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobFamilyCompetencyMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJobFamilyCompetencyMapping(id, jobFamilyCompetencyMapping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobFamilyCompetencyMappingsApi.updateJobFamilyCompetencyMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobFamilyCompetencyMappingsApi - factory interface
 */
export const JobFamilyCompetencyMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobFamilyCompetencyMappingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new job family competency mapping
         * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobFamilyCompetencyMapping(jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options?: RawAxiosRequestConfig): AxiosPromise<JobFamilyCompetencyMapping> {
            return localVarFp.createJobFamilyCompetencyMapping(jobFamilyCompetencyMapping, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job family competency mapping
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamilyCompetencyMapping(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteJobFamilyCompetencyMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all job family competency mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
         * @summary Delete job family competency mappings (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobFamilyCompetencyMappingsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteJobFamilyCompetencyMappingsBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job family competency mapping by ID
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobFamilyCompetencyMapping(id: string, options?: RawAxiosRequestConfig): AxiosPromise<JobFamilyCompetencyMapping> {
            return localVarFp.getJobFamilyCompetencyMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List job family competency mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobFamilyCompetencyMappings(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobFamilyCompetencyMapping>> {
            return localVarFp.listJobFamilyCompetencyMappings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job family competency mapping
         * @param {string} id Unique identifier of the job family competency mapping
         * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobFamilyCompetencyMapping(id: string, jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options?: RawAxiosRequestConfig): AxiosPromise<JobFamilyCompetencyMapping> {
            return localVarFp.updateJobFamilyCompetencyMapping(id, jobFamilyCompetencyMapping, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobFamilyCompetencyMappingsApi - object-oriented interface
 */
export class JobFamilyCompetencyMappingsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new job family competency mapping
     * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJobFamilyCompetencyMapping(jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options?: RawAxiosRequestConfig) {
        return JobFamilyCompetencyMappingsApiFp(this.configuration).createJobFamilyCompetencyMapping(jobFamilyCompetencyMapping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job family competency mapping
     * @param {string} id Unique identifier of the job family competency mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobFamilyCompetencyMapping(id: string, options?: RawAxiosRequestConfig) {
        return JobFamilyCompetencyMappingsApiFp(this.configuration).deleteJobFamilyCompetencyMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all job family competency mappings based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific mappings. Omit \'ids\' or provide empty array to delete all mappings (requires elevated permissions). 
     * @summary Delete job family competency mappings (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobFamilyCompetencyMappingsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return JobFamilyCompetencyMappingsApiFp(this.configuration).deleteJobFamilyCompetencyMappingsBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job family competency mapping by ID
     * @param {string} id Unique identifier of the job family competency mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobFamilyCompetencyMapping(id: string, options?: RawAxiosRequestConfig) {
        return JobFamilyCompetencyMappingsApiFp(this.configuration).getJobFamilyCompetencyMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List job family competency mappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listJobFamilyCompetencyMappings(options?: RawAxiosRequestConfig) {
        return JobFamilyCompetencyMappingsApiFp(this.configuration).listJobFamilyCompetencyMappings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job family competency mapping
     * @param {string} id Unique identifier of the job family competency mapping
     * @param {JobFamilyCompetencyMapping} jobFamilyCompetencyMapping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJobFamilyCompetencyMapping(id: string, jobFamilyCompetencyMapping: JobFamilyCompetencyMapping, options?: RawAxiosRequestConfig) {
        return JobFamilyCompetencyMappingsApiFp(this.configuration).updateJobFamilyCompetencyMapping(id, jobFamilyCompetencyMapping, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobLevelsApi - axios parameter creator
 */
export const JobLevelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new job level
         * @param {JobLevel} jobLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobLevel: async (jobLevel: JobLevel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobLevel' is not null or undefined
            assertParamExists('createJobLevel', 'jobLevel', jobLevel)
            const localVarPath = `/api/job-classification/job-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobLevel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job level
         * @param {string} id Unique identifier of the job level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobLevel', 'id', id)
            const localVarPath = `/api/job-classification/job-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all job levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific job levels. Omit \'ids\' or provide empty array to delete all job levels (requires elevated permissions). 
         * @summary Delete job levels (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobLevelsBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteJobLevelsBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/job-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job level by ID
         * @param {string} id Unique identifier of the job level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobLevel', 'id', id)
            const localVarPath = `/api/job-classification/job-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all job levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobLevels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/job-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job level
         * @param {string} id Unique identifier of the job level
         * @param {JobLevel} jobLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobLevel: async (id: string, jobLevel: JobLevel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobLevel', 'id', id)
            // verify required parameter 'jobLevel' is not null or undefined
            assertParamExists('updateJobLevel', 'jobLevel', jobLevel)
            const localVarPath = `/api/job-classification/job-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobLevel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobLevelsApi - functional programming interface
 */
export const JobLevelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobLevelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new job level
         * @param {JobLevel} jobLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobLevel(jobLevel: JobLevel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobLevel(jobLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobLevelsApi.createJobLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job level
         * @param {string} id Unique identifier of the job level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobLevelsApi.deleteJobLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all job levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific job levels. Omit \'ids\' or provide empty array to delete all job levels (requires elevated permissions). 
         * @summary Delete job levels (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobLevelsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobLevelsBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobLevelsApi.deleteJobLevelsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job level by ID
         * @param {string} id Unique identifier of the job level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobLevelsApi.getJobLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all job levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobLevels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobLevel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobLevelsApi.listJobLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job level
         * @param {string} id Unique identifier of the job level
         * @param {JobLevel} jobLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJobLevel(id: string, jobLevel: JobLevel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJobLevel(id, jobLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobLevelsApi.updateJobLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobLevelsApi - factory interface
 */
export const JobLevelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobLevelsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new job level
         * @param {JobLevel} jobLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobLevel(jobLevel: JobLevel, options?: RawAxiosRequestConfig): AxiosPromise<JobLevel> {
            return localVarFp.createJobLevel(jobLevel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job level
         * @param {string} id Unique identifier of the job level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobLevel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteJobLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all job levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific job levels. Omit \'ids\' or provide empty array to delete all job levels (requires elevated permissions). 
         * @summary Delete job levels (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobLevelsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteJobLevelsBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job level by ID
         * @param {string} id Unique identifier of the job level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobLevel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<JobLevel> {
            return localVarFp.getJobLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all job levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobLevels(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobLevel>> {
            return localVarFp.listJobLevels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job level
         * @param {string} id Unique identifier of the job level
         * @param {JobLevel} jobLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobLevel(id: string, jobLevel: JobLevel, options?: RawAxiosRequestConfig): AxiosPromise<JobLevel> {
            return localVarFp.updateJobLevel(id, jobLevel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobLevelsApi - object-oriented interface
 */
export class JobLevelsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new job level
     * @param {JobLevel} jobLevel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJobLevel(jobLevel: JobLevel, options?: RawAxiosRequestConfig) {
        return JobLevelsApiFp(this.configuration).createJobLevel(jobLevel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job level
     * @param {string} id Unique identifier of the job level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobLevel(id: string, options?: RawAxiosRequestConfig) {
        return JobLevelsApiFp(this.configuration).deleteJobLevel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all job levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific job levels. Omit \'ids\' or provide empty array to delete all job levels (requires elevated permissions). 
     * @summary Delete job levels (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJobLevelsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return JobLevelsApiFp(this.configuration).deleteJobLevelsBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job level by ID
     * @param {string} id Unique identifier of the job level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobLevel(id: string, options?: RawAxiosRequestConfig) {
        return JobLevelsApiFp(this.configuration).getJobLevel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all job levels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listJobLevels(options?: RawAxiosRequestConfig) {
        return JobLevelsApiFp(this.configuration).listJobLevels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job level
     * @param {string} id Unique identifier of the job level
     * @param {JobLevel} jobLevel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJobLevel(id: string, jobLevel: JobLevel, options?: RawAxiosRequestConfig) {
        return JobLevelsApiFp(this.configuration).updateJobLevel(id, jobLevel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillClustersApi - axios parameter creator
 */
export const SkillClustersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new skill cluster
         * @param {SkillCluster} skillCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkillCluster: async (skillCluster: SkillCluster, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillCluster' is not null or undefined
            assertParamExists('createSkillCluster', 'skillCluster', skillCluster)
            const localVarPath = `/api/job-classification/skill-clusters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillCluster, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a skill cluster
         * @param {string} id Unique identifier of the skill cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillCluster: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSkillCluster', 'id', id)
            const localVarPath = `/api/job-classification/skill-clusters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all skill clusters based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific clusters. Omit \'ids\' or provide empty array to delete all clusters (requires elevated permissions). 
         * @summary Delete skill clusters (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillClustersBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteSkillClustersBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/skill-clusters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a skill cluster by ID
         * @param {string} id Unique identifier of the skill cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillCluster: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSkillCluster', 'id', id)
            const localVarPath = `/api/job-classification/skill-clusters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all skill clusters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillClusters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/skill-clusters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a skill cluster
         * @param {string} id Unique identifier of the skill cluster
         * @param {SkillCluster} skillCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkillCluster: async (id: string, skillCluster: SkillCluster, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSkillCluster', 'id', id)
            // verify required parameter 'skillCluster' is not null or undefined
            assertParamExists('updateSkillCluster', 'skillCluster', skillCluster)
            const localVarPath = `/api/job-classification/skill-clusters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillCluster, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillClustersApi - functional programming interface
 */
export const SkillClustersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillClustersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new skill cluster
         * @param {SkillCluster} skillCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSkillCluster(skillCluster: SkillCluster, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillCluster>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSkillCluster(skillCluster, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillClustersApi.createSkillCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a skill cluster
         * @param {string} id Unique identifier of the skill cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillCluster(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillCluster(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillClustersApi.deleteSkillCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all skill clusters based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific clusters. Omit \'ids\' or provide empty array to delete all clusters (requires elevated permissions). 
         * @summary Delete skill clusters (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillClustersBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillClustersBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillClustersApi.deleteSkillClustersBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a skill cluster by ID
         * @param {string} id Unique identifier of the skill cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkillCluster(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillCluster>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkillCluster(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillClustersApi.getSkillCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all skill clusters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkillClusters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SkillCluster>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkillClusters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillClustersApi.listSkillClusters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a skill cluster
         * @param {string} id Unique identifier of the skill cluster
         * @param {SkillCluster} skillCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSkillCluster(id: string, skillCluster: SkillCluster, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillCluster>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSkillCluster(id, skillCluster, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillClustersApi.updateSkillCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillClustersApi - factory interface
 */
export const SkillClustersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillClustersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new skill cluster
         * @param {SkillCluster} skillCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkillCluster(skillCluster: SkillCluster, options?: RawAxiosRequestConfig): AxiosPromise<SkillCluster> {
            return localVarFp.createSkillCluster(skillCluster, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a skill cluster
         * @param {string} id Unique identifier of the skill cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillCluster(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSkillCluster(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all skill clusters based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific clusters. Omit \'ids\' or provide empty array to delete all clusters (requires elevated permissions). 
         * @summary Delete skill clusters (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillClustersBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteSkillClustersBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a skill cluster by ID
         * @param {string} id Unique identifier of the skill cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillCluster(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SkillCluster> {
            return localVarFp.getSkillCluster(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all skill clusters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillClusters(options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillCluster>> {
            return localVarFp.listSkillClusters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a skill cluster
         * @param {string} id Unique identifier of the skill cluster
         * @param {SkillCluster} skillCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkillCluster(id: string, skillCluster: SkillCluster, options?: RawAxiosRequestConfig): AxiosPromise<SkillCluster> {
            return localVarFp.updateSkillCluster(id, skillCluster, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillClustersApi - object-oriented interface
 */
export class SkillClustersApi extends BaseAPI {
    /**
     * 
     * @summary Create a new skill cluster
     * @param {SkillCluster} skillCluster 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSkillCluster(skillCluster: SkillCluster, options?: RawAxiosRequestConfig) {
        return SkillClustersApiFp(this.configuration).createSkillCluster(skillCluster, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a skill cluster
     * @param {string} id Unique identifier of the skill cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillCluster(id: string, options?: RawAxiosRequestConfig) {
        return SkillClustersApiFp(this.configuration).deleteSkillCluster(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all skill clusters based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific clusters. Omit \'ids\' or provide empty array to delete all clusters (requires elevated permissions). 
     * @summary Delete skill clusters (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillClustersBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return SkillClustersApiFp(this.configuration).deleteSkillClustersBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a skill cluster by ID
     * @param {string} id Unique identifier of the skill cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSkillCluster(id: string, options?: RawAxiosRequestConfig) {
        return SkillClustersApiFp(this.configuration).getSkillCluster(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all skill clusters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSkillClusters(options?: RawAxiosRequestConfig) {
        return SkillClustersApiFp(this.configuration).listSkillClusters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a skill cluster
     * @param {string} id Unique identifier of the skill cluster
     * @param {SkillCluster} skillCluster 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSkillCluster(id: string, skillCluster: SkillCluster, options?: RawAxiosRequestConfig) {
        return SkillClustersApiFp(this.configuration).updateSkillCluster(id, skillCluster, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillLevelsApi - axios parameter creator
 */
export const SkillLevelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new skill level
         * @param {SkillLevel} skillLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkillLevel: async (skillLevel: SkillLevel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillLevel' is not null or undefined
            assertParamExists('createSkillLevel', 'skillLevel', skillLevel)
            const localVarPath = `/api/job-classification/skill-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillLevel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a skill level
         * @param {string} id Unique identifier of the skill level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSkillLevel', 'id', id)
            const localVarPath = `/api/job-classification/skill-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all skill levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific levels. Omit \'ids\' or provide empty array to delete all levels (requires elevated permissions). 
         * @summary Delete skill levels (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillLevelsBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteSkillLevelsBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/skill-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a skill level by ID
         * @param {string} id Unique identifier of the skill level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSkillLevel', 'id', id)
            const localVarPath = `/api/job-classification/skill-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all skill levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/skill-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a skill level
         * @param {string} id Unique identifier of the skill level
         * @param {SkillLevel} skillLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkillLevel: async (id: string, skillLevel: SkillLevel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSkillLevel', 'id', id)
            // verify required parameter 'skillLevel' is not null or undefined
            assertParamExists('updateSkillLevel', 'skillLevel', skillLevel)
            const localVarPath = `/api/job-classification/skill-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillLevel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillLevelsApi - functional programming interface
 */
export const SkillLevelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillLevelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new skill level
         * @param {SkillLevel} skillLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSkillLevel(skillLevel: SkillLevel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSkillLevel(skillLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelsApi.createSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a skill level
         * @param {string} id Unique identifier of the skill level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelsApi.deleteSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all skill levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific levels. Omit \'ids\' or provide empty array to delete all levels (requires elevated permissions). 
         * @summary Delete skill levels (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillLevelsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillLevelsBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelsApi.deleteSkillLevelsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a skill level by ID
         * @param {string} id Unique identifier of the skill level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkillLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkillLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelsApi.getSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all skill levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkillLevels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SkillLevel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkillLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelsApi.listSkillLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a skill level
         * @param {string} id Unique identifier of the skill level
         * @param {SkillLevel} skillLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSkillLevel(id: string, skillLevel: SkillLevel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSkillLevel(id, skillLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelsApi.updateSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillLevelsApi - factory interface
 */
export const SkillLevelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillLevelsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new skill level
         * @param {SkillLevel} skillLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkillLevel(skillLevel: SkillLevel, options?: RawAxiosRequestConfig): AxiosPromise<SkillLevel> {
            return localVarFp.createSkillLevel(skillLevel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a skill level
         * @param {string} id Unique identifier of the skill level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillLevel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSkillLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all skill levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific levels. Omit \'ids\' or provide empty array to delete all levels (requires elevated permissions). 
         * @summary Delete skill levels (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillLevelsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteSkillLevelsBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a skill level by ID
         * @param {string} id Unique identifier of the skill level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SkillLevel> {
            return localVarFp.getSkillLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all skill levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevels(options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillLevel>> {
            return localVarFp.listSkillLevels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a skill level
         * @param {string} id Unique identifier of the skill level
         * @param {SkillLevel} skillLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkillLevel(id: string, skillLevel: SkillLevel, options?: RawAxiosRequestConfig): AxiosPromise<SkillLevel> {
            return localVarFp.updateSkillLevel(id, skillLevel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillLevelsApi - object-oriented interface
 */
export class SkillLevelsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new skill level
     * @param {SkillLevel} skillLevel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSkillLevel(skillLevel: SkillLevel, options?: RawAxiosRequestConfig) {
        return SkillLevelsApiFp(this.configuration).createSkillLevel(skillLevel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a skill level
     * @param {string} id Unique identifier of the skill level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillLevel(id: string, options?: RawAxiosRequestConfig) {
        return SkillLevelsApiFp(this.configuration).deleteSkillLevel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all skill levels based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific levels. Omit \'ids\' or provide empty array to delete all levels (requires elevated permissions). 
     * @summary Delete skill levels (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillLevelsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return SkillLevelsApiFp(this.configuration).deleteSkillLevelsBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a skill level by ID
     * @param {string} id Unique identifier of the skill level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSkillLevel(id: string, options?: RawAxiosRequestConfig) {
        return SkillLevelsApiFp(this.configuration).getSkillLevel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all skill levels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSkillLevels(options?: RawAxiosRequestConfig) {
        return SkillLevelsApiFp(this.configuration).listSkillLevels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a skill level
     * @param {string} id Unique identifier of the skill level
     * @param {SkillLevel} skillLevel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSkillLevel(id: string, skillLevel: SkillLevel, options?: RawAxiosRequestConfig) {
        return SkillLevelsApiFp(this.configuration).updateSkillLevel(id, skillLevel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillTypesApi - axios parameter creator
 */
export const SkillTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new skill type
         * @param {SkillType} skillType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkillType: async (skillType: SkillType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillType' is not null or undefined
            assertParamExists('createSkillType', 'skillType', skillType)
            const localVarPath = `/api/job-classification/skill-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a skill type
         * @param {string} id Unique identifier of the skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillType: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSkillType', 'id', id)
            const localVarPath = `/api/job-classification/skill-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all skill types based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific types. Omit \'ids\' or provide empty array to delete all types (requires elevated permissions). 
         * @summary Delete skill types (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillTypesBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteSkillTypesBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/skill-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a skill type by ID
         * @param {string} id Unique identifier of the skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillType: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSkillType', 'id', id)
            const localVarPath = `/api/job-classification/skill-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all skill types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/skill-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a skill type
         * @param {string} id Unique identifier of the skill type
         * @param {SkillType} skillType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkillType: async (id: string, skillType: SkillType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSkillType', 'id', id)
            // verify required parameter 'skillType' is not null or undefined
            assertParamExists('updateSkillType', 'skillType', skillType)
            const localVarPath = `/api/job-classification/skill-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillTypesApi - functional programming interface
 */
export const SkillTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new skill type
         * @param {SkillType} skillType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSkillType(skillType: SkillType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSkillType(skillType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillTypesApi.createSkillType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a skill type
         * @param {string} id Unique identifier of the skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillType(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillTypesApi.deleteSkillType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all skill types based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific types. Omit \'ids\' or provide empty array to delete all types (requires elevated permissions). 
         * @summary Delete skill types (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillTypesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillTypesBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillTypesApi.deleteSkillTypesBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a skill type by ID
         * @param {string} id Unique identifier of the skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkillType(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkillType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillTypesApi.getSkillType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all skill types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkillTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SkillType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkillTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillTypesApi.listSkillTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a skill type
         * @param {string} id Unique identifier of the skill type
         * @param {SkillType} skillType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSkillType(id: string, skillType: SkillType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSkillType(id, skillType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillTypesApi.updateSkillType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillTypesApi - factory interface
 */
export const SkillTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new skill type
         * @param {SkillType} skillType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkillType(skillType: SkillType, options?: RawAxiosRequestConfig): AxiosPromise<SkillType> {
            return localVarFp.createSkillType(skillType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a skill type
         * @param {string} id Unique identifier of the skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillType(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSkillType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all skill types based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific types. Omit \'ids\' or provide empty array to delete all types (requires elevated permissions). 
         * @summary Delete skill types (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillTypesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteSkillTypesBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a skill type by ID
         * @param {string} id Unique identifier of the skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillType(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SkillType> {
            return localVarFp.getSkillType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all skill types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillType>> {
            return localVarFp.listSkillTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a skill type
         * @param {string} id Unique identifier of the skill type
         * @param {SkillType} skillType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkillType(id: string, skillType: SkillType, options?: RawAxiosRequestConfig): AxiosPromise<SkillType> {
            return localVarFp.updateSkillType(id, skillType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillTypesApi - object-oriented interface
 */
export class SkillTypesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new skill type
     * @param {SkillType} skillType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSkillType(skillType: SkillType, options?: RawAxiosRequestConfig) {
        return SkillTypesApiFp(this.configuration).createSkillType(skillType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a skill type
     * @param {string} id Unique identifier of the skill type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillType(id: string, options?: RawAxiosRequestConfig) {
        return SkillTypesApiFp(this.configuration).deleteSkillType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all skill types based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific types. Omit \'ids\' or provide empty array to delete all types (requires elevated permissions). 
     * @summary Delete skill types (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillTypesBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return SkillTypesApiFp(this.configuration).deleteSkillTypesBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a skill type by ID
     * @param {string} id Unique identifier of the skill type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSkillType(id: string, options?: RawAxiosRequestConfig) {
        return SkillTypesApiFp(this.configuration).getSkillType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all skill types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSkillTypes(options?: RawAxiosRequestConfig) {
        return SkillTypesApiFp(this.configuration).listSkillTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a skill type
     * @param {string} id Unique identifier of the skill type
     * @param {SkillType} skillType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSkillType(id: string, skillType: SkillType, options?: RawAxiosRequestConfig) {
        return SkillTypesApiFp(this.configuration).updateSkillType(id, skillType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillsApi - axios parameter creator
 */
export const SkillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new skill
         * @param {Skill} skill 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkill: async (skill: Skill, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skill' is not null or undefined
            assertParamExists('createSkill', 'skill', skill)
            const localVarPath = `/api/job-classification/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skill, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a skill
         * @param {string} id Unique identifier of the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkill: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSkill', 'id', id)
            const localVarPath = `/api/job-classification/skills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all skills based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific skills. Omit \'ids\' or provide empty array to delete all skills (requires elevated permissions). 
         * @summary Delete skills (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillsBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deleteSkillsBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/job-classification/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a skill by ID
         * @param {string} id Unique identifier of the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSkill', 'id', id)
            const localVarPath = `/api/job-classification/skills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all skills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-classification/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a skill
         * @param {string} id Unique identifier of the skill
         * @param {Skill} skill 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkill: async (id: string, skill: Skill, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSkill', 'id', id)
            // verify required parameter 'skill' is not null or undefined
            assertParamExists('updateSkill', 'skill', skill)
            const localVarPath = `/api/job-classification/skills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skill, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillsApi - functional programming interface
 */
export const SkillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new skill
         * @param {Skill} skill 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSkill(skill: Skill, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSkill(skill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.createSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a skill
         * @param {string} id Unique identifier of the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkill(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.deleteSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all skills based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific skills. Omit \'ids\' or provide empty array to delete all skills (requires elevated permissions). 
         * @summary Delete skills (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkillsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkillsBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.deleteSkillsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a skill by ID
         * @param {string} id Unique identifier of the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkill(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.getSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all skills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Skill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.listSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a skill
         * @param {string} id Unique identifier of the skill
         * @param {Skill} skill 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSkill(id: string, skill: Skill, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSkill(id, skill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.updateSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillsApi - factory interface
 */
export const SkillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new skill
         * @param {Skill} skill 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkill(skill: Skill, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.createSkill(skill, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a skill
         * @param {string} id Unique identifier of the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkill(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all skills based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific skills. Omit \'ids\' or provide empty array to delete all skills (requires elevated permissions). 
         * @summary Delete skills (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkillsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deleteSkillsBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a skill by ID
         * @param {string} id Unique identifier of the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.getSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all skills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkills(options?: RawAxiosRequestConfig): AxiosPromise<Array<Skill>> {
            return localVarFp.listSkills(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a skill
         * @param {string} id Unique identifier of the skill
         * @param {Skill} skill 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkill(id: string, skill: Skill, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.updateSkill(id, skill, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillsApi - object-oriented interface
 */
export class SkillsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new skill
     * @param {Skill} skill 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSkill(skill: Skill, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).createSkill(skill, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a skill
     * @param {string} id Unique identifier of the skill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkill(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).deleteSkill(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all skills based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific skills. Omit \'ids\' or provide empty array to delete all skills (requires elevated permissions). 
     * @summary Delete skills (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSkillsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).deleteSkillsBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a skill by ID
     * @param {string} id Unique identifier of the skill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSkill(id: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).getSkill(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all skills
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSkills(options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).listSkills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a skill
     * @param {string} id Unique identifier of the skill
     * @param {Skill} skill 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSkill(id: string, skill: Skill, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).updateSkill(id, skill, options).then((request) => request(this.axios, this.basePath));
    }
}



